var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-edit-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-white",
    clipPath: "url(#clip-edit-white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27831",
    "data-name": "Group 27831",
    transform: "translate(7917.354 -15580.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30196",
    "data-name": "Rectangle 30196",
    width: 30,
    height: 30,
    rx: 15,
    transform: "translate(-7917.354 15580.264)",
    fill: "#7f9dbf",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-7909.354 15587.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34065",
    "data-name": "Path 34065",
    d: "M11.671,90.731a.614.614,0,0,0-.614.614v4.914a.615.615,0,0,1-.614.614h-8.6a.615.615,0,0,1-.614-.614v-8.6a.615.615,0,0,1,.614-.614H6.757a.614.614,0,0,0,0-1.229H1.843A1.845,1.845,0,0,0,0,87.659v8.6A1.845,1.845,0,0,0,1.843,98.1h8.6a1.845,1.845,0,0,0,1.843-1.843V91.345A.614.614,0,0,0,11.671,90.731Zm0,0",
    transform: "translate(0 -82.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34066",
    "data-name": "Path 34066",
    d: "M182.332,73.122a.311.311,0,0,0-.084.157l-.434,2.172a.307.307,0,0,0,.3.367.292.292,0,0,0,.06-.006l2.171-.434a.306.306,0,0,0,.157-.084l4.86-4.86-2.171-2.171Zm0,0",
    transform: "translate(-176.576 -65.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34067",
    "data-name": "Path 34067",
    d: "M394.467.95a1.537,1.537,0,0,0-2.171,0l-.85.85,2.171,2.171.85-.85a1.536,1.536,0,0,0,0-2.171Zm0,0",
    transform: "translate(-380.177)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.b732093019ceac7b85ab0ade4e43351a.svg";
export { ForwardRef as ReactComponent };